import React, { useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";
import SEO from "@/components/app/SEO";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function ForgotPasswordPage() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await axios.post(`${API}/auth/password-reset/request`, { email });
      setDone(true);
    } catch {
      // Toujours neutre — ne rien révéler
      setDone(true);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="mx-auto max-w-md px-4 py-16">
      <SEO title="Mot de passe oublié" description="Réinitialisez votre mot de passe Résiliation Express." canonical="/mot-de-passe-oublie" noindex />
      <div className="card-elevated p-6 sm:p-8">
        <h1 className="text-2xl sm:text-3xl font-bold tracking-tight mb-2">Mot de passe oublié&nbsp;?</h1>
        <p className="text-sm text-muted-foreground mb-6">
          Entrez votre adresse email. Si un compte y est associé, vous recevrez un lien de réinitialisation valable 30&nbsp;minutes.
        </p>

        {done ? (
          <div className="space-y-4" data-testid="forgot-done-panel">
            <div className="rounded-md bg-secondary/60 p-4 text-sm">
              Si un compte correspond à cette adresse, un email de réinitialisation a été envoyé. Vérifiez votre boîte de réception et vos spams.
            </div>
            <Button asChild variant="outline" className="w-full">
              <Link to="/connexion" data-testid="back-to-login">Retour à la connexion</Link>
            </Button>
          </div>
        ) : (
          <form onSubmit={submit} className="space-y-4" data-testid="forgot-form">
            <div>
              <Label htmlFor="fp-email">Adresse email</Label>
              <Input
                id="fp-email"
                data-testid="forgot-email"
                type="email"
                inputMode="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                autoComplete="email"
                className="text-base"
              />
            </div>
            <Button
              type="submit"
              disabled={loading}
              className="w-full bg-gradient-brand text-white border-0 hover:opacity-90"
              data-testid="forgot-submit-btn"
            >
              {loading ? "Envoi..." : "Recevoir le lien de réinitialisation"}
            </Button>
            <p className="text-center text-sm">
              <Link to="/connexion" className="text-muted-foreground hover:text-foreground">← Retour à la connexion</Link>
            </p>
          </form>
        )}
      </div>
    </div>
  );
}
